<template>
    <div class="text-center">
        <img
            v-if="collection.logo_image"
            :data-src="`${$scope.CDN_IMAGES}/images/site/parceiros/logos/${collection.logo_image}?fit=max&h=200&w=350`"
            class="img-responsive lazy lazy-fade mx-auto my-4"
            style="max-height: 100px; max-width: 175px"
        />

        <h1 v-else class="text-info">
            {{ collection.name }}
        </h1>

        <ul class="product-list product-list-5">
            <li
                v-for="(product, index) in collection.products.data.slice(
                    0,
                    Math.min(6, collection.products.data.length)
                )"
                :class="{
                    'hidden-xs-down': index === 4,
                    'hidden-xs-down hidden-md-up': index === 5,
                }"
                class="product-list-item text-center"
            >
                <a :href="product.link">
                    <div class="aspect aspect-shirt bg-default-1 rounded overflow-hidden">
                        <img
                            :data-src="getImageLink(product.img_thumb)"
                            class="product-list-item-photo lazy lazy-fade img-responsive"
                        />
                    </div>
                </a>
            </li>
        </ul>

        <ul></ul>

        <a :href="collection.catalog_url" class="btn btn-primary my"> Ver coleção </a>
    </div>
</template>

<script>
    import ProductGroupList from '../product/ProductGroupList';
    import { appendQueryString, updateLazyLoad } from '../../../common/common';
    import ProductCatalogPrice from '../product/ProductCatalogPrice';

    export default {
        name: 'Collection',

        components: { ProductCatalogPrice, ProductGroupList },

        props: {
            collection: {
                type: Object,
                required: true,
            },
        },

        mounted() {
            updateLazyLoad();
        },

        methods: {
            getName(art) {
                return art.name.replace('Camiseta ', '');
            },

            getImageLink(url) {
                return appendQueryString(url, {
                    auto: 'compress,format',
                    q: 65,
                    w: 500,
                });
            },
        },
    };
</script>
